resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function TabbedContent() {
  this.extends = [_ResponsiveLayout];
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this._idIncrementer = -1;

  this.init = function() {
    // Setup view
    if ($(this.node).hasClass("expanded")) {
      this.showExpandedView();
    } else {
      this.showCollapsedView();
    }

    $(this.node).on("change", this._setupTabsAccessibility.bind(this));
  };

  this.initAllReady = function() {
    $(this.node).css("display", "block");
  };

  this.showCollapsedView = function() {
    $(this.node).removeClass("expanded");
    this._toggleAccessibilityFeaturesForView(false);
  };

  this.showExpandedView = function() {
    $(this.node).addClass("expanded");
    this._toggleAccessibilityFeaturesForView(true);
  };

  this._toggleAccessibilityFeaturesForView = function(expandedView) {
    var tabs = $(this.node).find(".tab");

    if (expandedView) {
      $(this.node).removeAttr("role");
      for (var i = 0; i < tabs.length; i++) {
        var radio = $(tabs[i]).find("> input[type='radio']");
        var panel = $(tabs[i]).find(".tab__content");
        radio.removeAttr("role");
        radio.removeAttr("aria-controls");
        radio.removeAttr("aria-selected");
        panel.removeAttr("role");
        panel.removeAttr("aria-labelledby");
        panel.removeAttr("aria-hidden");
      }
    } else {
      $(this.node).attr("role", "tablist");
      for (var i = 0; i < tabs.length; i++) {
        var radio = $(tabs[i]).find("> input[type='radio']");
        var panel = $(tabs[i]).find(".tab__content");
        this._generateId(radio);
        this._generateId(panel);
        radio.attr("role", "tab");
        panel.attr("role", "tabpanel");
        radio.attr("aria-controls", panel.attr("id"));
        panel.attr("aria-labelledby", radio.attr("id"));
        if (radio[0].checked) {
          radio.attr("aria-selected", "true");
          panel.attr("aria-hidden", "false");
        } else {
          radio.attr("aria-selected", "false");
          panel.attr("aria-hidden", "true");
        }
      }
    }
  };

  this._setupTabsAccessibility = function(evt) {
    if (!$(this.node).hasClass("expanded") && $(evt.target).attr("role") === "tab") {
      var tabs = $(this.node).find(".tab");
      for (var i = 0; i < tabs.length; i++) {
        var radio = $(tabs[i]).find("> input[type='radio']");
        var panel = $(tabs[i]).find(".tab__content");
        if (radio[0].checked) {
          radio.attr("aria-selected", "true");
          panel.attr("aria-hidden", "false");
        } else {
          radio.attr("aria-selected", "false");
          panel.attr("aria-hidden", "true");
        }
      }
    }
  };

  this._generateId = function(node) {
    if (!$(node).attr("id")) {
      this._idIncrementer++;
      $(node).attr("id", this.id + "_" + this._idIncrementer);
    }
  };
}
